"use client";
import Image from "next/image";
import { useRouter } from "next/navigation";

const About = ({ data }: any) => {
  const router = useRouter();
  if (!data || data.length === 0) return null;

  return (
    <>
      <style>{`
        .about-section {
          background: #f7f8fc;
          padding: 4rem 0;
        }
        .about-container {
          max-width: 1200px;
          margin: 0 auto;
          padding: 0 1.5rem;
          display: flex;
          align-items: center;
          gap: 4rem;
          flex-wrap: wrap;
        }
        .about-text { flex: 1 1 360px; }
        .about-image-wrap {
          flex: 1 1 320px;
          border-radius: 1rem;
          overflow: hidden;
          box-shadow: 0 8px 32px rgba(63,65,209,0.1);
          position: relative;
          min-height: 320px;
        }
        .about-read-more {
          display: inline-flex;
          align-items: center;
          gap: 0.4rem;
          background: #3f41d1;
          color: #fff;
          border: none;
          border-radius: 2rem;
          padding: 0.65rem 1.5rem;
          font-size: 0.875rem;
          font-weight: 500;
          cursor: pointer;
          transition: background 0.2s, transform 0.2s;
          text-decoration: none;
        }
        .about-read-more:hover { background: #2d2fa8; transform: translateY(-1px); }
        @media (max-width: 768px) {
          .about-container { gap: 2rem; }
          .about-image-wrap { min-height: 220px; }
        }
      `}</style>

      <section className="about-section">
        <div className="about-container">
          <div className="about-text">
            <div
              style={{
                fontSize: "0.75rem",
                fontWeight: 600,
                color: "#3f41d1",
                textTransform: "uppercase",
                letterSpacing: "0.1em",
                marginBottom: "0.5rem",
              }}
            >
              Who We Are
            </div>
            <h2
              style={{
                fontSize: "1.6rem",
                fontWeight: 700,
                color: "#1a1a1a",
                lineHeight: 1.3,
                marginBottom: "1rem",
                fontFamily: "Graphik, sans-serif",
              }}
            >
              {data[0]?.attributes?.Title}
            </h2>
            <p
              style={{
                color: "#555",
                fontSize: "0.95rem",
                lineHeight: 1.8,
                marginBottom: "1.75rem",
                fontFamily: "Graphik, sans-serif",
              }}
            >
              {data[0]?.attributes?.Content}
            </p>
            <button
              className="about-read-more"
              onClick={() => router.push("/about-us")}
            >
              Read More <i className="bi bi-arrow-right"></i>
            </button>
          </div>

          <div className="about-image-wrap">
            <Image
              src={data[0]?.attributes?.Image_Path}
              alt="About us"
              fill
              style={{ objectFit: "cover" }}
            />
          </div>
        </div>
      </section>
    </>
  );
};

export default About;
